import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const EbookReader = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M.334 4.001c0-.184.15-.333.333-.333h2a.333.333 0 1 1 0 .667H1.001v10.332h14V4.335h-1.667a.333.333 0 1 1 0-.667h2c.184 0 .333.15.333.333v11c0 .184-.15.333-.333.333H.667a.333.333 0 0 1-.333-.333V4Z" />
        <path d="M8.001 3.668c.184 0 .334.15.334.333v5.333a.333.333 0 0 1-.667 0V4.001c0-.184.15-.333.333-.333Z" />
        <path d="M2.334 2.667c0-.184.15-.333.333-.333 3.032 0 4.507.565 5.33 1.22.813-.668 2.284-1.22 5.337-1.22.184 0 .333.15.333.333V12c0 .184-.15.334-.333.334-3.31 0-4.524.674-5.1 1.238a.333.333 0 0 1-.47-.003c-.573-.574-1.81-1.235-5.097-1.235A.333.333 0 0 1 2.334 12V2.667Zm.667.336v8.666c2.813.04 4.215.574 5.001 1.217.78-.632 2.162-1.177 4.998-1.217V3.003c-3.05.043-4.21.68-4.764 1.233a.333.333 0 0 1-.466.005C7.2 3.694 6.02 3.047 3 3.003Z" />
      </g>
    </svg>
  );
};

EbookReader.category = 'product-category';

EbookReader.displayName = 'EbookReader';
